import React from 'react';
import css from './css.less';
import EditableTable, {
  BackTitle,
} from '@/src/components/EditableTable/EditableTable';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { instanceType, AllTypes } from 'src/tools/helper';
import { TableNumberInput } from 'src/components/EditableTable/TableForm/TableForm';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import { EnumTablePosition } from 'src/types/common/common';
const ExpandTable = (props) => {
  const { keyProps, data, parentIndex, onChange, deletable = true } = props;
  const col = [
    {
      key: 'expand',
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      width: 100,
      default: true,
    },
    {
      key: 'title',
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      minWidth: 200,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        //const { price, priceError } = record;
        return (
          <NoWrapContainer>
            <Tooltip title={record.productName}>{record.productName}</Tooltip>
          </NoWrapContainer>
        );
      },
      key: 'item',
      minWidth: 315,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        return (
          <NoWrapContainer>
            <BackTitle> {record.noOfUnit}</BackTitle>
          </NoWrapContainer>
        );
      },
      position: EnumTablePosition.right,
      key: 'noOfUnit',
      minWidth: 100,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        const { unitPrice, unitPriceError } = record;
        return (
          <div className={css.expandItems}>
            <TableNumberInput
              size='small'
              mode={EnumMode.money}
              error={unitPriceError}
              rightPosition
              value={unitPrice}
              onChange={(e) => {
                // 未编辑允许展示 null，但提交时要提交 unitPrice 0，setPrice null
                if (instanceType(e) === AllTypes.Null && deletable) {
                  onChange(parentIndex, index, { unitPrice: null });
                }
                if (instanceType(e) === AllTypes.Null && !deletable) {
                  onChange(parentIndex, index, { unitPrice: 0 });
                }
                onChange(parentIndex, index, { unitPrice: e });
              }}
            />
          </div>
        );
      },
      position: EnumTablePosition.right,
      key: 'unitPrice',
      minWidth: 100,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      key: 'setPrice',
      minWidth: 100,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      key: 'setPrice',
      minWidth: 100,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      key: 'currency',
      minWidth: 100,
      default: true,
    },
    {
      childGenerate: (text, record, index) => {
        return <React.Fragment />;
      },
      key: 'notes',
      minWidth: 100,
      default: true,
    },
  ];

  return (
    <div className={css.expandContainer}>
      <EditableTable
        rowKey={'key'}
        showHeader={false}
        rowClassName={css.tableRowClassName}
        data={data}
        columns={col}
        id={`ProductSetPriceAdvancedSetting${keyProps}`}
      />
    </div>
  );
};
export default ExpandTable;
